<div #echartsContainer echarts [options]="echartsOptions" class="uruk-chart" (chartInit)="onChartInit($event)"></div>
